import type { CityBuilding } from './types';

/**
 * Para onde cada prédio da cidade leva, nas rotas que este produto realmente
 * tem.
 *
 * ⚠️ O mapa que veio colado (`_incoming/dashboard3d/src/app/cidade/page.tsx`)
 * apontava para `/questoes`, `/flashcards`, `/simulados` e `/disciplinas`.
 * **Três dessas rotas não existem aqui, e a quarta é pior que não existir:**
 *
 * | Colado | Problema | Aqui |
 * |---|---|---|
 * | `/questoes` | existe, mas é `gated(ADMIN)` — o banco de questões. Um aluno cairia no `<AccessDenied>` | `/carrossel` (o treino) |
 * | `/flashcards` | não existe | `/revisao` |
 * | `/simulados` | não existe | `/agenda/completa` |
 * | `/disciplinas` | não existe | `/carrossel` |
 *
 * ⚠️ **`/agenda/completa` é `gated(SIMULADO)`, e `SIMULADO` não inclui
 * `competidor`** (`app/auth/accessPolicy.ts`), embora `competidor` conte como
 * pagante em `PAID` e portanto alcance o `/home` onde este painel mora. Um
 * `competidor` que clicar no prédio de simulados vê a negativa de acesso. Isso
 * **espelha o menu**: o `Sidebar.tsx` esconde o submenu Simulado desse perfil
 * exatamente assim, e o CLAUDE.md registra a exclusão como deliberada, a
 * corrigir nos dois lugares de uma vez. Não é regressão deste painel.
 */
export const CITY_ROUTES: Record<CityBuilding, string> = {
  questoes: '/carrossel',
  flashcards: '/revisao',
  simulados: '/agenda/completa',
  disciplinas: '/carrossel',
};

/**
 * O destino de um clique num prédio.
 *
 * ⚠️ **O `subjectId` que a cidade manda é descartado de propósito.** O original
 * navegava para `` `${rota}?subjectId=${id}` ``, e aqui isso seria um parâmetro
 * morto: `/carrossel` não lê query param nenhum — quem decide o conteúdo dele é
 * o `useQuestionFiltersStore`, cujo rascunho vive no `localStorage` e só vale
 * depois de um `apply()`. Honrar a matéria pedida significa escrever nesse store
 * antes de navegar, o que reescreveria os filtros que o aluno já tinha — é
 * mudança própria, não um parâmetro a acrescentar na URL.
 */
export function cityDestination(building: CityBuilding): string {
  return CITY_ROUTES[building];
}
